import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgProjectManagementIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 10s.1213-.8492 3.636-4.364c3.5148-3.5147 9.2132-3.5147 12.728 0 1.2452 1.2453 2.0493 2.7647 2.4122 4.364M2 10V4m0 6h6m14 4s-.1213.8492-3.636 4.364c-3.5148 3.5147-9.2132 3.5147-12.728 0C4.3908 17.1187 3.5867 15.5993 3.2238 14M22 14v6m0-6h-6"
    />
  </svg>
);
export default SvgProjectManagementIcon;
